import React, { useCallback, useEffect, useState } from 'react';
import { useFormState } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

const COMPONENTE_FRETE_TIPO_RECOLHIMENTO_LISTA = ['PREPAID', 'COLLECT'];

export default function QCXSelectComponenteFreteTipoRecolhimentoAutocomplete({ id, key, label, name, ...restProps }) {
  const { values } = useFormState();
  const [defaultValue, setDefaultValue] = useState('');
  useEffect(() => {
    const value = COMPONENTE_FRETE_TIPO_RECOLHIMENTO_LISTA.find((item) => item.id === Number(_.get(values, name)));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [values]);

  const getOptionLabel = useCallback((item) => item, []);
  const filterOptions = createFilterOptions({ stringify: getOptionLabel });

  return (
    <QCXAutocompleteSelect
      id={id}
      key={key}
      label={label}
      name={name}
      options={COMPONENTE_FRETE_TIPO_RECOLHIMENTO_LISTA}
      filterOptions={filterOptions}
      getOptionValue={getOptionLabel}
      getOptionLabel={getOptionLabel}
      defaultValue={defaultValue}
      {...restProps}
    />
  );
}
